import { useState } from "react";
import { Shield } from "lucide-react";
import { getBadgeUrl } from "@/data/clanBadges";

/**
 * Klan rozetini gösterir. badge_id CR API'sinden gelir.
 * Rozet bulunamazsa (bilinmeyen id ya da resim yüklenemezse) Shield ikonuna düşer.
 *
 * size prop → yaklaşık piksel boyut; CDN'de dinamik olarak resize edilir.
 */
export default function ClanBadge({
  badgeId,
  size = 32,
  className = "",
  alt = "Klan rozeti",
}) {
  const [errored, setErrored] = useState(false);
  const url = getBadgeUrl(badgeId, { size: size * 2 }); // 2x for retina
  const px = `${size}px`;

  const style = { width: px, height: px, minWidth: px, minHeight: px };

  if (!url || errored) {
    return (
      <div
        style={style}
        className={`inline-flex items-center justify-center rounded-md bg-primary/15 text-primary ${className}`}
        aria-label={alt}
      >
        <Shield style={{ width: size * 0.6, height: size * 0.6 }} />
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      onError={() => setErrored(true)}
      style={style}
      className={`inline-block object-contain drop-shadow-sm ${className}`}
    />
  );
}
